/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useEffect, useCallback, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRejectedAccountProducts, fetchPendingAccountProducts, fetchAccountProducts, fetchApprovedAccountProducts } from 'state/thunks/account';
// utils
// material
import { Page, Content, InContentMessage, Button, displayModal, history, EmptyState } from '@insticator/insticator-ui';
import PageHeader from "material/structure/pageheader/pageheader";
import PageContent from "material/structure/pagecontent/pagecontent";
import SiteFilter from 'material/sitefilter/sitefilter';
import LoadingState from 'material/states/loading/loading';
// content
import Space from 'material/space/space';
import CodeSetup from './codesetup/codesetup';
import PublishWarning from './publishwarning/publishwarning';
// styles
import injectSheet from "react-jss";
import styles from './productmanagerconfig_styles';
import PageSetup from './pagesetup/pagesetup';
import { getProductManagerConfig } from 'state/thunks/productmanager';
import ProductAccess from './productaccess/productaccess';
import { useIsAdminUser } from 'utils/session';
import { revertProductManagerConfigChanges } from 'state/slices/productmanager';
import PageSetupV2 from './pagesetup/pagesetupv2';


/* ========== ~~~~~~~~~~ MODERATION CONFIG PAGE ~~~~~~~~~~ ========== */
const ProductManagerConfig  = injectSheet(styles)((props) => {
  const dispatch = useDispatch();
  const { siteUUID } = useSelector(state => state.session);
  const { productManagerConfigChanges, productManagerConfig, tempProductManagerConfig } = useSelector(state => state.productManager)
  const { accountProducts } = useSelector((state) => state.account);
  const noProductAccess = useMemo(() => accountProducts.length === 0, [accountProducts])

  const [isLoading,setIsLoading] = useState(true)
  const isAdmin = useIsAdminUser()

  const fetchProductManagerConfig = useCallback(async()=>{
    setIsLoading(true)
    await dispatch(getProductManagerConfig({ siteId: siteUUID }))
    setIsLoading(false)
  }, [dispatch, siteUUID])

  useEffect(() => {
    if(siteUUID) fetchProductManagerConfig()
  }, [fetchProductManagerConfig, siteUUID]) 

  const isProductManagerConfigChanged = useMemo(() => {
    return !(JSON.stringify(productManagerConfig) === JSON.stringify(tempProductManagerConfig));
  },[productManagerConfig, tempProductManagerConfig])

  // const isProductGroupsValid = useMemo(() => {
  //   const isAllProductGroupLabelValid = tempProductManagerConfig.groupConfigList.filter(group => group.draft.label === '' || group.current.label === '').length === 0
  //   return isAllProductGroupLabelValid
  // }, [tempProductManagerConfig])


  const accountUUID = useSelector((state) => state.session.accountUUID)

  useEffect(() => {
    if(!accountUUID) return
    dispatch(fetchApprovedAccountProducts(accountUUID))
    dispatch(fetchPendingAccountProducts(accountUUID))
    dispatch(fetchRejectedAccountProducts(accountUUID))
  }, [accountUUID, dispatch])

  const showPublishWarning = (action = '') => dispatch(displayModal(true, <PublishWarning action={action} />, false))

  const handleCancel = useCallback(async () => {
    await dispatch(revertProductManagerConfigChanges())
  }, [dispatch])

  const showPublishChangeButton = !productManagerConfigChanges.includes('groupConfigList')
  const globalSave = isProductManagerConfigChanged && (
    <div className={'globalsave'}>
      <Space justifyContent={'flex-end'}>
        <Button variant={'none'} color={'light'} name={'savedraft'} text={'Cancel'} handleClick={handleCancel} />
        {showPublishChangeButton ?
         <Button variant={'none'} color={'compliment'} name={'setascurrent'} text={'Publish Changes'} handleClick={() => showPublishWarning('')} />
         :
         <Button variant={'primary'} name={'savedraft'} text={'Save Draft & Preview Changes'} handleClick={() => showPublishWarning('saveDraft')} />
        }
        
      </Space>
    </div>
  )

  return (
    <Page name={'productmanagerpage'} klass={`productmanagerpage ${props.classes.productmanagerpage}`}>
      <SiteFilter hideTestPageButton />
      <Content>
        <InContentMessage />
        <PageHeader title={'Product Manager'} />
        <PageContent>
        { isLoading  ?
          <LoadingState />
          :
          <>
            <ProductAccess />
            { isAdmin &&
              <div className={`disabled-${noProductAccess}`}>
                <CodeSetup />
                <PageSetupV2 />
                <div style={{position: 'absolute', bottom: 0, left: '0px', width: '100%'}}>
                {globalSave}
                </div>
              </div>
            } 
          </>
        }
        </PageContent>
      </Content>
    </Page>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ProductManagerConfig